import { lazy } from 'react';

const CharityVettingAcceptsAllFoodsEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingAcceptsAllFoods" */ '../components/steps/charity-accepts-all-food-step/CharityAcceptsAllFoods'
    ),
);

export default CharityVettingAcceptsAllFoodsEntry;
